import { Button, UIHeading2, UIText2 } from '@cian/ui-kit';
import classNames from 'classnames';
import * as React from 'react';

import { EDeviceType } from '../../types/device';

import * as styles from './ResultsEmpty.css';

const heartIcon = require('./img/heart.svg');

export interface IResultsEmptyStoreProps {
  isAuthenticated: boolean;
  deviceType: EDeviceType;
  onClickSearch(): void;
}

export type TResultsEmptyProps = IResultsEmptyStoreProps;

export function ResultsEmptyFolder({ isAuthenticated, deviceType, onClickSearch }: IResultsEmptyStoreProps) {
  return (
    <div className={styles['container']}>
      <div className={styles['wrapper']}>
        <div className={classNames(styles['content'], styles['content-folder'])}>
          <div className={styles['empty-background']} />
          <div className={styles['title']}>
            <UIHeading2>В подборке нет объявлений</UIHeading2>
          </div>
          <div className={styles['description']}>
            <UIText2>
              Сохраняйте объявления в подборки, нажимая на{' '}
              <img className={styles['icon']} src={heartIcon} alt="Добавить в избранное" /> в поиске️, а затем на кнопку
              «Сохранить в подборку» в появившемся ниже уведомлении
            </UIText2>
          </div>
          <Button size={deviceType === EDeviceType.Desktop ? 'XS' : 'M'} theme="fill_primary" onClick={onClickSearch}>
            {isAuthenticated ? 'Искать объявления' : 'Войти'}
          </Button>
        </div>
      </div>
    </div>
  );
}
